import { render, staticRenderFns } from "./PdfViewV2.vue?vue&type=template&id=7bc359b6&scoped=true"
import script from "./PdfViewV2.vue?vue&type=script&lang=js"
export * from "./PdfViewV2.vue?vue&type=script&lang=js"
import style0 from "./PdfViewV2.vue?vue&type=style&index=0&id=7bc359b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc359b6",
  null
  
)

export default component.exports